// Visual style per zone type — fill + outline colors used on Course Map and
// anywhere else zones render. Kept in a single place so color choices stay
// consistent and the palette is easy to audit.

import type { ZoneType } from '@greeniq/shared';

interface ZoneStyle {
  fill: string;
  outline: string;
  label: string;
}

export const ZONE_TYPE_STYLE: Record<ZoneType, ZoneStyle> = {
  green: { fill: '#22A060', outline: '#0F3F23', label: 'Green' },
  tee_complex: { fill: '#8DBC96', outline: '#166534', label: 'Tee' },
  fairway: { fill: '#5FA06D', outline: '#166534', label: 'Fairway' },
  rough: { fill: '#B8A372', outline: '#8A7750', label: 'Rough' },
  bunker: { fill: '#F5E9C7', outline: '#B8A372', label: 'Bunker' },
  cart_path: { fill: '#94A3B8', outline: '#475569', label: 'Cart Path' },
  practice: { fill: '#DCEBDE', outline: '#166534', label: 'Practice' },
  nursery: { fill: '#B8D7BE', outline: '#166534', label: 'Nursery' },
  maintenance: { fill: '#E2E8F0', outline: '#475569', label: 'Maintenance' },
  water_feature: { fill: '#7DD3FC', outline: '#0369A1', label: 'Water' },
};
